let currentLanguage = "en"

const LanguageService = {
  getLanguage: () => currentLanguage,
  setLanguage: lang => (currentLanguage = lang),
}

export default LanguageService
